import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import MapOverlayAnchorProjectionService from '../../../../../services/mapOverlayAnchorProjectionService';
import WGS84Service from '../../../../../services/wgs84ProjectionService';
import debounce from 'lodash/debounce';
export default {
  name: 'CoreDtwinMapOverlayWizardContainer',
  props: {
    addressObject: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    twinImages: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      overlayImageId: null,
      imageFileName: null,
      imageSrc: null,
      rotatedImage: null,
      anchorCanvasWidth: 0,
      anchor1: {
        position: {},
        latlon: {}
      },
      anchor2: {
        position: {},
        latlon: {}
      },
      processedInfo: {
        image: null,
        ne: {},
        sw: {}
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions', 'UiTheme'])), {}, {
    hasCompleteInfo: function hasCompleteInfo() {
      if (!this.anchor1.position.x || !this.anchor1.latlon.lat) {
        return false;
      }

      if (!this.anchor2.position.x || !this.anchor2.latlon.lat) {
        return false;
      }

      return true;
    },
    overlayInfo: function overlayInfo() {
      if (!this.processedInfo.image) {
        return null;
      }

      if (!WGS84Service.isValidWgs84(this.processedInfo.ne)) {
        return null;
      }

      if (!WGS84Service.isValidWgs84(this.processedInfo.sw)) {
        return null;
      } // https://docs.mapbox.com/mapbox-gl-js/style-spec/sources/#image
      // https://docs.mapbox.com/mapbox-gl-js/example/image-on-a-map/


      return {
        image: this.processedInfo.image,
        coordinates: [[this.processedInfo.sw.lon, this.processedInfo.ne.lat], [this.processedInfo.ne.lon, this.processedInfo.ne.lat], [this.processedInfo.ne.lon, this.processedInfo.sw.lat], [this.processedInfo.sw.lon, this.processedInfo.sw.lat]]
      };
    }
  }),
  watch: {
    imageSrc: function imageSrc() {
      this.debouncedCanvasWidthCalc();
    }
  },
  mounted: function mounted() {
    this.debouncedCanvasWidthCalc();
  },
  created: function created() {
    window.addEventListener('resize', this.debouncedCanvasWidthCalc);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.debouncedCanvasWidthCalc);
  },
  methods: {
    getAttachmentDownloadUrl: function getAttachmentDownloadUrl(file) {
      return "".concat(process.env.VUE_APP_API_HOST).concat(process.env.VUE_APP_API_PATH, "/upload/").concat(file.id);
    },
    overlayImageSelected: function overlayImageSelected() {
      var _this = this;

      if (this.overlayImageId) {
        this.imageFileName = this.twinImages.find(function (f) {
          return f.id === _this.overlayImageId;
        }).name;
        this.imageSrc = this.getAttachmentDownloadUrl({
          id: this.overlayImageId
        });
      } else {
        this.imageFileName = null;
        this.imageSrc = null;
      }
    },
    debouncedCanvasWidthCalc: debounce(function () {
      this.anchorCanvasWidth = this.$refs['image-anchor-picker-container'].clientWidth;
    }, 250),
    onFileChange: function onFileChange(e) {
      e.stopPropagation();
      e.preventDefault();
      var files = (e.target || {}).files || e.dataTransfer.files;

      if (!files.length) {
        return;
      }

      this.handleFile(files[0]);
    },
    handleFile: function handleFile(file) {
      if (file.type.match(/image.*/)) {
        this.imageFileName = file.name;
        var context = this;
        var reader = new FileReader();

        reader.onload = function (e) {
          context.imageSrc = e.target.result; // TODO: SETUP MAP HERE
          // context.$refs.gmaps.resetMap();
        };

        reader.readAsDataURL(file);
      }
    },
    handleDragOver: function handleDragOver(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    },
    updateAnchor1Position: function updateAnchor1Position(position) {
      this.anchor1.position = position;
    },
    updateAnchor2Position: function updateAnchor2Position(position) {
      this.anchor2.position = position;
    },
    movedAnchor1Coordinate: function movedAnchor1Coordinate(coordinate) {
      this.anchor1.latlon = coordinate;
    },
    movedAnchor2Coordinate: function movedAnchor2Coordinate(coordinate) {
      this.anchor2.latlon = coordinate;
    },
    processOverlayImage: function processOverlayImage() {
      var canvas = this.$refs['image-anchor-picker'];
      var anchors = [{
        screenPoint: this.anchor1.position,
        coordinate: this.anchor1.latlon
      }, {
        screenPoint: this.anchor2.position,
        coordinate: this.anchor2.latlon
      }];
      var info = MapOverlayAnchorProjectionService.getBoundsAndRotation(anchors, canvas.image.orgDimension.width, canvas.image.orgDimension.height);
      var tempCanvas = document.createElement('canvas');
      tempCanvas.setAttribute('width', info.size.width);
      tempCanvas.setAttribute('height', info.size.height);
      var context = tempCanvas.getContext('2d'); // http://stackoverflow.com/a/5983173/5460596

      var image = canvas.image.htmlEl;
      context.translate(0.5 * image.width, 0.5 * image.height);
      var resizedWidth = 0.5 * (info.size.width - image.width);
      var resizedHeight = 0.5 * (info.size.height - image.height);
      context.translate(resizedWidth, resizedHeight);
      context.rotate(info.rotation);
      context.drawImage(image, -image.width * 0.5, -image.height * 0.5);
      context.restore();
      var img = tempCanvas.toDataURL('image/png');
      this.processedInfo = {
        image: img,
        imageFileName: this.imageFileName,
        ne: {
          lat: info.north,
          lon: info.east
        },
        sw: {
          lat: info.south,
          lon: info.west
        }
      };
    }
  }
};